module.exports = __webpack_public_path__ + "static/img/topbanner.79c6ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/index/topbanner.png
// module id = 675
// module chunks = 1